import request from '@/utils/request'

// 业务领域
export function getBusinessList() {
    return request({
        url: '/gtwg/pc/businessList',
        method: 'get'
    })
}